export default function HeadingSmallCell({ value }: { value: string }) {
    return (
        <div
            className={` ${!navigator.userAgent.includes("Safari") ? "min-w-max" : "whitespace-nowrap"} text-center`}
        >
            {value}
        </div>
    );
}
